<template>
    <div v-title title="支付结果"  class="overwrite_productDetail" style="height: 100vh;overflow-y: auto;overflow-x: hidden;background-color: #ffffff;">

        <!--<van-nav-bar-->
                <!--title="支付结果"-->
                <!--@click-left="onClickLeft">-->

            <!--<span slot="left">-->
               <!--<van-icon name="arrow-left" color="#323233" size="20" />-->
            <!--</span>-->
        <!--</van-nav-bar>-->

        <div class="width100 product_img_center" style="height: 20vh;margin-top: 10vh">
            <div>
                <van-icon v-if="isSuccess" size="150" color="#00754a" name="checked" />
                <van-icon v-if="!isSuccess" size="150" color="#f2250f" name="clear" />
            </div>
        </div>
        <div class="width100 text-center font500" style="font-size: 2.5rem;margin-bottom: 1.5vh">
            {{isSuccess?'订单支付成功!':'订单支付失败'}}
        </div>
        <div class="width100 text-center font-pain-grey" style="font-size: 1.5rem">

            {{isSuccess?'您可在"我的--我的订单"中查看订单详情!':'请稍后重试'}}
        </div>

        <div slot="default" style="width: 100vw;padding: 10vh 5vw 0 5vw;box-sizing: border-box">
            <van-button size="normal" :color="isSuccess?'#00754a':'linear-gradient(to right, #ff6034, #ee0a24)'" block>
                {{isSuccess?'确定':'返回'}}
            </van-button>
        </div>

        <div ref="maidian" td-event="2668024000,https://cloudmall.counton.com.cn/commbank-ip/#/payResult"></div>
    </div>
</template>

<script>
    import { baseUrl } from 'common/env'
    import { Search } from 'vant';
    import { areaList } from '@vant/area-data';
    import { postnotoken } from 'api/postnotoken'
    import { get } from 'api/get'
    import TabBar from '@/components/tabBar/index'

    export default {
        name:'home',
        components: {
            TabBar
        },
        data() {
            return {
                isSuccess:true,

            };
        },
        created() {
            let self = this
            this.$nextTick(() => {
                self.$refs['maidian'].click()
            })
        },
        methods: {
            onClickLeft(){
                this.$router.push("/");
            }
        }
    };
</script>

<style>
    .overwrite_productOrderList{
        display: flex;
        flex-direction: row;
    }

   .overwrite_productOrderList .van-sidebar-item--select::before{
       background-color: #00754a;
   }

    .overwrite_productOrderList .van-grid{
        background: #fff;
    }
</style>

<style scoped>
    .my-swipe {
        margin: 0 10px;
        border-radius: 10px;;
    }

    .my-swipe .van-swipe-item {
        color: #fff;
        font-size: 20px;
        line-height: 150px;
        text-align: center;
        background-color: #39a9ed;
    }

</style>



// WEBPACK FOOTER //
// src/view/product/payResult.vue